var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['badge', _vm.shape, _vm.bgColor]},[(_vm.hasIcon)?_vm._t("icon"):_c('p',{staticClass:"badge-text"},[_vm._t("text")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }